/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="packageTypes.module.ts" />

module Meevo.Plugins.PackageTypes {
    class PackageTypesController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "meevo.components.common.RoundingService",
            "$translate",
            "$filter",
            "$document",
            "$timeout"
        ];

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected roundingService: Meevo.Components.Common.IRoundingService,
            protected $translate: angular.translate.ITranslateService,
            protected $filter: angular.IFilterService,
            protected $document: angular.IDocumentService,
            protected $timeout: angular.ITimeoutService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.DATA_PACKAGETYPE).then(() => {
                this.busyService.stop();
                this.context = new PackageTypesContext(
                    this.appSettings,
                    this.dataService,
                    this.modalService,
                    this.identityService,
                    this.loggingService,
                    this.securityService,
                    this.trackingService,
                    this.busyService,
                    this.roundingService,
                    this.$translate,
                    this.$filter,
                    this.$scope
                );

                this.context.activate(this.selectedItemId, null, this.asLocationId);

                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };

                // Use translate service to populate field list
                this.context.locationFieldList = [
                    { field: 'ObjectState', label: this.$translate.instant("HEADER_STATUS"), checked: false },
                ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

        getAuditCriteria() {
            if (!this.context || !this.context.selectedSection) {
                return null;
            }

            return (<any>this.context.selectedSection).customAuditCriteria;
        }
    }

    angular.module("meevo.plugins.packageTypes")
        .controller("meevo.plugins.packageTypes.PackageTypesController", PackageTypesController);
}